import { empty } from '../../../js/util/util-functions';

export default {
  props: {
    minlength: {
      type: Number,
      required: true,
      default: 1,
    },
    maxlength: {
      type: Number,
      required: true,
      default: Number.MAX_SAFE_INTEGER,
    },
  },
  methods: {
    validateField(value) {
      this.$store.commit('updateFormFieldValidity', {
        name: this.propertyName,
        valid: (
          true === this.optional
          && true === empty(value)) // Field can be optional and invalid
          || true === this.validateStringLength(value),
      });
    },
    validateStringLength(value) {
      if (!value) return false;
      return value.length >= this.minlength && value.length <= this.maxlength;
    },
  },
};
